<template>
  <v-card>
    <v-card-text>
      <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
      <v-row dense>
        <v-col>
          <v-combobox
              v-model="estatus"
              :items="lstEstatus"
              label="Estatus"
              required
              :rules="[reglas.requeridoTxt]"
              item-value="id"
              item-text="descripcion"
              return-object
              clearable
              @change="handleChangeEstatus()"
          ></v-combobox>
        </v-col>
        <v-col>
          <v-text-field
            type="date"
            v-model="datosEstatus.fecha"
            label="Fecha"
            clearable
          >
          </v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            type="time"
            v-model="datosEstatus.hora"
            label="Hora"
            clearable
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="6">
          <v-textarea
            label="Comentarios"
            v-model="datosEstatus.comentarios"
            append-icon="mdi-file-edit"
            clearable
          ></v-textarea>
        </v-col>
      </v-row>
      <div v-if="podFlag">
        <v-subheader>Información de POD</v-subheader>
        <v-row dense>
          <v-col>
              <v-text-field
                  label="Persona que Recibe"
                  v-model="pod_nombre"
                  append-icon="mdi-file-edit"
                  ></v-text-field>
          </v-col>
          <v-col>
              <v-text-field
                  label="DNI"
                  v-model="pod_dni"
                  append-icon="mdi-card"
                  ></v-text-field>
          </v-col>
        </v-row>
      </div>
      <v-row dense>
        <v-spacer></v-spacer>
        <v-col style="text-align: end;">
          <v-btn
                  outlined
                  color="primary"
                  elevation="5"
                  @click="addEstatusGuia()"
                >
                  Agregar Estatus
                  <v-icon>mdi-arrow-right-bold-circle</v-icon>
                </v-btn>
        </v-col>
      </v-row>
      <v-row dense>
          <v-col>
            <v-card
              outlined
              elevation="5"
            >
              <v-card-text>
                <v-data-table
                  :headers="headers"
                  :items="estatusDeGuia"
                >
                  <template v-slot:item.acciones="{ item }">
                    <v-btn
                      icon
                      color="red"
                      @click="deleteStatus(item)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        </v-form>
    </v-card-text>
  </v-card>
</template>
<script>
import apicon from '../plugins/apicon';
export default {
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  data(){
    return {
      datosEstatus: {
                id_estatus: null,
                fecha: null,
                hora: null,
                comentarios: null
            },
            lstEstatus: [],
            estatus: null,
            podFlag : false,
            pod_nombre: null,
            pod_dni: null,
            headers: [
              { text: 'Estatus', value: 'estatus.descripcion' },
              { text: 'Fecha', value: 'fecha' },
              { text: 'Hora', value: 'hora' },
              { text: 'Comentarios', value: 'comentarios' },
              { text: 'Acciones', value: 'acciones' }
            ],
            estatusDeGuia: [],
            valid: true,
    }
  },
  watch: {
    estatus: function(item){
            if(item){
                this.datosEstatus.id_estatus = item.id;
            }
        },
  },
  methods:{
    getEstatusDeGuia: function () {
      apicon
        .getDataApi(
          apicon.getApiBaseUrl() + 'historialestatuscl/' + this.id
        )
        .then((result) => {
          this.estatusDeGuia = result
        })
    },
    getLstEstatus: function () {
        apicon
          .getDataApi(apicon.getApiBaseUrl() + 'estatusall')
          .then((result) => {
            this.lstEstatus = result
          })
      },
      addEstatusGuia:async function () {
      if (this.$refs.form.validate()) {
        var guiasLst = [];
        var guiaA = {
            id_guia: this.id,
          };

          guiasLst.push(guiaA);
          let lstGuias = JSON.stringify(guiasLst);

          await apicon
              .saveDataApi(apicon.getApiBaseUrl() + "actualizarestatusguiascl", {
                id_estatus : this.estatus.id,
                fecha: this.datosEstatus.fecha,
                hora: this.datosEstatus.hora,
                comentarios : this.datosEstatus.comentarios,
                pod_nombre : this.pod_nombre,
                pod_dni : this.pod_dni,
                pod_fecha : this.estatus.codigo === 'OK' ? this.datosEstatus.fecha : null,
                pod_hora : this.estatus.codigo === 'OK' ? this.datosEstatus.hora : null,
                guias : lstGuias
              })
              .then((result) => {
                console.log(result);
                this.getEstatusDeGuia();
                this.limpiar();
              });
      }
    },
    handleChangeEstatus: function(){
        if(this.estatus.codigo === 'OK'){
          this.podFlag = true;
        }else{
          this.podFlag = false;
        }
      },
      limpiar: function () {
      this.$refs.form.resetValidation()
      this.estatus = null
      this.datosEstatus.id_estatus = null
      this.datosEstatus.fecha = null
      this.datosEstatus.hora = null
      this.datosEstatus.comentarios = null
      this.pod_dni = null
      this.pod_nombre = null
      this.podFlag = false
    },
    deleteStatus: function (item) {
      var self = this
      this.$swal(this.dswalEliminar).then((resultdlg) => {
        if (resultdlg.value) {
          var url = apicon.getApiBaseUrl() + 'delestatuscl/' + item.id
          apicon.deleteDataApi(url).then((result) => {
            self.getEstatusDeGuia()
            this.$swal(result.message)
          })
        }
      })
    },
  },
  mounted: async function(){
        await apicon.setAuthHeaders();
        this.getLstEstatus();
        this.getEstatusDeGuia();
    }
};
</script>

<style>
</style>
